module.exports = __webpack_public_path__ + "img/tit2.3220dfb1.png";